import React from 'react';
import PropTypes from 'prop-types';

import { CopyToClipboard } from 'react-copy-to-clipboard';

import './Copy.css';

const Copy = ({
  copyText,
  onCopy,
  onClick,
  btnText,
  noIcon,
  className,
  children,
}) => {
  return (
    <CopyToClipboard
      text={copyText}
      onCopy={onCopy}
    >
      <div
        className={`copy-button-element__component ${className}`}
        onClick={onClick}
      >
        {!noIcon && !children &&
          <div className="icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="50" viewBox="0 0 48 50"><g id="ic_copy_full"><path d="M33.605 33.777v9.651c0 2.78-2.035 4.825-4.801 4.825H4.798c-2.766 0-4.801-2.045-4.801-4.825V19.301c0-2.78 2.035-4.826 4.801-4.826H14.4v-9.65c0-2.78 2.035-4.826 4.802-4.826h24.005c2.766 0 4.801 2.046 4.801 4.826v24.127c0 2.78-2.035 4.825-4.801 4.825h-9.602zm-4.801 0h-9.602c-2.767 0-4.802-2.045-4.802-4.825v-9.651H4.798v24.127h24.006v-9.651zM19.202 4.825v24.127h24.005V4.825H19.202z" /></g></svg>
          </div>
        }
        {btnText && !children &&
          <div className="text">{btnText}</div>
        }
        {children}
      </div>
    </CopyToClipboard>
  );
};

Copy.propTypes = {
  copyText: PropTypes.string.isRequired,
  onCopy: PropTypes.func,
  onClick: PropTypes.func,
  btnText: PropTypes.string,
  noIcon: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string, PropTypes.object]),
};
Copy.defaultProps = {
  onCopy: null,
  onClick: null,
  btnText: 'Copy',
  className: '',
  children: null,
};

export default Copy;
